export default class ZohoForm {
  constructor(element) {
    this.element = element;
    this.init();
  }

  init() {

    if (!this.element.dataset.zohoformSrc || !this.element.dataset.zohoformSrc.includes('http')) {
      console.error("Zoho Form: Missing data-zohoform-src attribute");
      return;
    }
    try {
      const iframe = document.createElement("iframe");
      iframe.src = this.element.dataset.zohoformSrc;
      iframe.style.border = "none";
      iframe.style.height = this.element.dataset.zohoformHeight || "500px";
      iframe.style.width = this.element.dataset.zohoformWidth || "100%";
      iframe.style.transition = "all 0.5s ease";
      iframe.setAttribute("aria-label", this.element.dataset.zohoformName || "Zoho Form");

      const container = this.element;
      container.appendChild(iframe);

      window.addEventListener("message", (event) => {
        const evntData = event.data;
        if (evntData && evntData.constructor === String) {
          const zf_ifrm_data = evntData.split("|");
          if (zf_ifrm_data.length === 2 || zf_ifrm_data.length === 3) {
            const zf_perma = zf_ifrm_data[0];
            const zf_ifrm_ht_nw = `${parseInt(zf_ifrm_data[1], 10) + 15}px`;
            const iframe = this.element.getElementsByTagName("iframe")[0];

            if (iframe.src.includes("formperma") && iframe.src.includes(zf_perma)) {
              const prevIframeHeight = iframe.style.height;
              let zf_tout = false;

              if (zf_ifrm_data.length === 3) {
                iframe.scrollIntoView();
                zf_tout = true;
              }

              if (prevIframeHeight !== zf_ifrm_ht_nw) {
                if (zf_tout) {
                  setTimeout(() => {
                    iframe.style.height = zf_ifrm_ht_nw;
                  }, 500);
                } else {
                  iframe.style.height = zf_ifrm_ht_nw;
                }
              }
            }
          }
        }
      }, false);
    } catch (e) {
      console.error(e);
    }
  }
}
